import React from 'react'
import styled from 'styled-components'



const Wrapper= styled.section`
.section{
  padding-top: 5%;
  padding-bottom: 9%;
}

h2{
  color:#EC632F;
  text-align: center;
}
.btn-combo{
  padding-top: 7%;
  padding-bottom: 6%;
  display: flex;
  gap: 5px;
  flex-direction: row;
  justify-content: center;
}
.button-1{
  color: #fff;
  width: 120px;
  font-weight: bold;
  height: 40px;
  border: none;
  border-radius: 1px solid #EC632F;
  background: #EC632F;
  border-radius: 5%;
}
.button-2{
  color: #fff;
  border: none;
  font-weight: bold;
  border-radius: 5%;
  background: #EC632F;
  width: 120px;
  height: 40px;
}

img{
  width: 90%;
  display: flex;
  margin: 0 auto;
}
p{
  color: #C8C8C8;
  margin-left:21px;
  margin-right: 40px;
line-height: 1.5;
margin-bottom: 6%;
margin-top: 3%;
}

.Our-programs-include{
  h3{
    margin-left:21px;
    padding-bottom: 4%;
    padding-top: 3%;
  }
  ul{
    
    list-style: disc;
    margin-left:40px;
display: flex;
flex-direction: column;
gap: 5px;
  }
  li{
    color: #C8C8C8;

  }
  li a{
    color :orange;
  }

  .second-ul{
  display: none;
}
}



@media (min-width: 768px) {

  .section{
  padding-top: 5%;
  padding-bottom: 2%;
}

.img-text-combo{
  display: flex;
  align-items: center;
  margin: 0 20px;
  gap: 10px;
}
img{
  width: 50%;
  height: 480px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}
.btn-combo{
  padding-top: 3%;
  padding-bottom: 7%;
  display: flex;
  gap: 5px;
  flex-direction: row;
  justify-content: center;
}
p{
  color: #C8C8C8;
  margin-left:21px;
  margin-right: 10px;
line-height: 1.5;
margin-bottom: 6%;
margin-top: 3%;
}
.Our-programs-include{
  h3{
    margin-left:21px;
    padding-bottom: 4%;
    padding-top: 3%;
  }
  ul{
    
    list-style: disc;
    margin-left:40px;
display: flex;
flex-direction: column;
gap: 10px;
  }
  li{
    color: #C8C8C8;

  }
  li a{
    color :orange;
    display: none;
  }
}
}


@media (min-width: 992px) {

  .section{
  padding-top: 5%;
  padding-bottom: 2%;
}

.img-text-combo{
  display: flex;
  margin: 0 40px;
  gap: 10px;
  align-items: center;
}
img{
  width: 50%;
  height: 550px;
  object-fit: cover;
  display: flex;
  margin: 0 ;
}

p{
  color: #C8C8C8;
  margin-left:21px;
  margin-right: 20px;
line-height: 1.5;
margin-bottom: 6%;
margin-top: 3%;
}

.btn-combo{
  padding-top: 2%;
  padding-bottom: 7%;
display: flex;
  gap: 15px;
  flex-direction: row;
  justify-content: center;
}
.button-1{
  font-size: 21px;
  width: 140px;
  height: 50px;
  border-radius: 1px solid #EC632F;
}
.button-2{
  font-size: 21px;
  width: 140px;
  height: 50px;
}


.Our-programs-include{
  .ul-divs-combo{
    display: flex;
    gap: 45px;
  }

  .second-ul{
  list-style: disc;
   margin-left:0px;
display: flex;
flex-direction: column;
gap: 9px;
}
  h3{
    margin-left:40px;
    padding-bottom: 5%;
    padding-top: 6%;
  }
  ul{
    
    list-style: disc;
    margin-left:40px;
display: flex;
flex-direction: column;
gap: 9px;
  }
  li{
    color: #C8C8C8;

  }
  li a{
    color :orange;
  }
}
}
@media (min-width: 1200px) {
.text-div{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: none;
  border-left:1px solid green;
border-right: 1px solid green;
border-bottom: 1px solid green;
border-radius: 3%;


  width: 50%;
}
  .section{
  padding-top: 5%;
  padding-bottom: 2%;
}
.inner-div{
  width: 85%;
  background: none;
}
.img-text-combo{
  display: flex;
  flex-direction: row-reverse;
  margin: 0 90px;
    gap: 90px;
  align-items: center;
}
img{
  border-radius: 3%;
  width: 50%;
  height: 420px;
  object-fit: cover;
  display: flex;
  margin: 0 ;
}

p{
  color: #C8C8C8;
  margin-left:21px;
  margin-right: 20px;
line-height: 1.5;
margin-bottom: 6%;
margin-top: 3%;
}

.btn-combo{
  padding-top: 2%;
  padding-bottom: 7%;
display: flex;
  gap: 15px;
  flex-direction: row;
  justify-content: center;
}
.button-1{
  font-size: 21px;
  width: 140px;
  height: 50px;
  border-radius: 1px solid #EC632F;
}
.button-2{
  font-size: 21px;
  width: 140px;
  height: 50px;
}
h2{
  color:#EC632F;
  text-align: center;
  font-size: 33px;
  font-weight: 600;

}

.Our-programs-include{
  .ul-divs-combo{
    display: flex;
    gap: 45px;
  }

  .second-ul{
  list-style: disc;
   margin-left:0px;
display: flex;
flex-direction: column;
gap: 9px;
}
  h3{
    margin-left:40px;
    padding-bottom: 5%;
    padding-top: 0%;
  }
  ul{
    
    list-style: disc;
    margin-left:40px;
display: flex;
flex-direction: column;
gap: 9px;
  }
  li{
    color: #C8C8C8;

  }
  li a{
    color :orange;
  }
}
}





`
function OurServices() {
  return (
    <Wrapper>
      <div className='section'>
        <h2> Our Services</h2>
       <div className='btn-combo'>
        <button className='button-1' >Pre-School</button>
        <button className='button-2'>Day Care</button>
       </div>

       <div className='img-text-combo'>
       <img src="./photos/twokids.png" alt=""/>
       <div className='text-div'>
        <div className='inner-div'> 
         <p >We ignite minds (3-5 years) through play-based learning, nurturing confidence and fostering a love for exploration. Our vibrant classrooms become launchpads for success, where STEM activities fuel critical thinking, imaginative stories weave language magic, and social-emotional learning prepares them for kindergarten and beyond. Join us, and watch tiny explorers blossom into bright minds, ready to conquer the world!</p>

        <div className='Our-programs-include'>
            <h3>Our programs include</h3>
            <div className='ul-divs-combo'>
            <ul>
                <li>Family Movie Day</li>
                <li>Art & Creativity Studio</li>
                <li>Community Outings</li>
                <li>Parent Support Group</li>
                <li>Early Literacy Playdates</li>
                <li> <a>Learn more</a></li>
            </ul>

            <ul className='second-ul'>
          <li>Home work help</li>
          <li>Music & Movement Classes</li>
          <li>Sibling Playspace</li>
          <li>Health & Wellness Workshops</li>
        </ul>
        </div>
        </div>
         </div>
         </div>
       </div>


        




      </div>
    </Wrapper>
  )
}

export default OurServices
